import axios from 'axios'
import Vue from 'vue'
import { Toast } from 'vant'

Vue.use(Toast)

// 创建axios实例
const request = axios.create({
  baseURL: process.env.VUE_APP_URL_API // api的base_url
  // timeout: 5000                  // 请求超时时间
})

// request请求拦截器
// request.interceptors.request.use(
//   config => {
//     return config
//   },
//   error => {
//     Toast.fail(error.message)
//     return Promise.reject(error)
//   }
// )

// respone拦截器
request.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 0) {
      response.config.url !== '/api/wechatqiuqiu/js-dy-index/get-js-package' && Toast(res.errmsg)
      return Promise.reject(new Error(res.errmsg))
    } else {
      return res.data
    }
  },
  error => {
    Toast(error.message)
    return Promise.reject(error)
  }
)

export default request
